/**
 * Trace validators. Add a file in this folder and import it below.
 */
import traceEventsPresent from "./traceEventsPresent";
import tracePatientIdMatch from "./tracePatientIdMatch";
import traceAudioIngestCompleted from "./traceAudioIngestCompleted";
import traceAudioIngestStartEnd from "./traceAudioIngestStartEnd";
// import traceDiarizationCompleted from "./traceDiarizationCompleted"; // disabled for now
import traceChatgptCompleted from "./traceChatgptCompleted";
import traceSummarizationSla from "./traceSummarizationSla";

/** @type {import('../../types').ValidationTestDefinition[]} */
export const traceValidators = [
  traceEventsPresent,
  tracePatientIdMatch,
  traceAudioIngestCompleted,
  traceAudioIngestStartEnd,
  // traceDiarizationCompleted, // disabled for now
  traceChatgptCompleted,
  traceSummarizationSla,
].filter((test) => test && typeof test.run === "function");
